import { render, staticRenderFns } from "./InformationGeneral.vue?vue&type=template&id=2b4b9814&scoped=true"
import script from "./InformationGeneral.vue?vue&type=script&lang=js"
export * from "./InformationGeneral.vue?vue&type=script&lang=js"
import style0 from "./InformationGeneral.vue?vue&type=style&index=0&id=2b4b9814&prod&scoped=true&lang=css"
import style1 from "./InformationGeneral.vue?vue&type=style&index=1&id=2b4b9814&prod&lang=css"
import style2 from "./InformationGeneral.vue?vue&type=style&index=2&id=2b4b9814&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4b9814",
  null
  
)

export default component.exports